<template>
  <div class="row f-row justify-content-center">
    <div
      class="row f-row mt-1 mb-1 justify-content-center"
      style="vertical-align: middle!important;"
      v-show="!editable"
    >
      <div class="col col-1 txt-label-primary-2 text-center">
        CURRENCY:
      </div>
      <div class="col col-2 inline-ul selectDiv ml-2">
        <select
          class="dropdown-form ddown-hedge"
          v-model="newSelectedAsset"
          @change="onUserAssetSelection"
        >
          <option
            v-for="(currency, idx) in currencySpecs"
            :value="idx"
            :key="currency.pk_i_idcurrency"
            >{{ currency.currency_name.toUpperCase() }}
          </option>
        </select>
      </div>

      <div class="col col-1 txt-label-primary-2 text-center">
        {{ currencySpecs[newSelectedAsset].currency_name.slice(0, 3) }}:
      </div>
      <div class="col col-2 inline-ul">
        <label
          :for="'selectBuySell'"
          class="toggle__button_rt"
          style="height: 100%; width: 100%;"
          :class="{ actives: selectedPositionBoolean }"
        >
          <input
            type="checkbox"
            @click="onUserPositionChange"
            :id="'selectBuySell'"
            v-model="selectedPositionBoolean"
          />
          <span class="toggle__switch_rt" style="width: 100%;">
            <div class="row f-row justify-content-center">
              <div
                class="col col-6 txt-label-primary-2 text-center"
                style="font-size: 0.75rem!important;"
              >
                BUY
              </div>
              <div
                class="col col-6 txt-label-primary-2 text-center"
                style="font-size: 0.75rem!important;"
              >
                SELL
              </div>
            </div>
          </span>
        </label>
      </div>
    </div>
    <div
      class="row f-row mt-2 justify-content-center"
      style="vertical-align: middle!important;"
      v-show="!editable"
    >
      <div class="col col-3 txt-label-primary-2 text-center">
        <input
          type="button"
          id="strip"
          class="inputFileBlue"
          style="background: var(--expo)!important;"
          @click="showStripData = !showStripData"
        />
        <label for="strip">{{
          showStripData ? "Close" : "Define strip"
        }}</label>
      </div>
      <div class="col col-1">,</div>
      <div class="col col-3 txt-label-primary-2 text-center">
        <input
          type="file"
          name="file"
          id="file"
          class="inputFileBlue"
          @change="onChange"
        />
        <label for="file"><i class="fa fa-upload"></i> Choose a file...</label>
      </div>
      <div class="col col-1 txt-label-primary-2">or</div>
      <div class="col col-3 inline-ul txt-label-primary-2 text-center">
        <input
          v-model="textIn"
          style="width: 100%; background: var(--dark-expo-alpha)!important;
          color: var(--textactive-2)!important; border: 1px solid var(--expo)!important;"
          type="text"
          @paste="paste"
          class="btn-home btn btn-home-blue"
          placeholder="Paste dates/quantities"
        />
      </div>
    </div>
    <div class="col col-11" style="height: 100%; overflow: auto;">
      <table class="table table-sm table-borderless real_time_table mt-2">
        <thead class="table-headers text-center align-center thead">
          <tr>
            <th style="width: 70px" colspan="2" v-if="!editable">#</th>
            <th style="width: 30px" v-else>#</th>
            <th>DATE</th>
            <th>
              NOTIONAL ({{
                currencySpecs[newSelectedAsset].currency_name.slice(0, 3)
              }})
            </th>
            <th v-if="!editable">MID MKT FWD</th>
            <th v-for="(item, index) in strategyLegs" :key="index">
              {{ item.toUpperCase() }}
            </th>
          </tr>
        </thead>
      </table>
    </div>
    <div
      class="col col-11"
      style="overflow: auto; max-height: calc(70vh - 230px)!important;"
    >
      <table class="table table-sm table-borderless real_time_table">
        <tbody>
          <tr v-for="(item, index) in newUserNewHedge" :key="index" class="tr">
            <td
              style="width: 30px"
              v-bind:class="{ 'row-hover': highlightRow === index }"
              @mouseover="onHoverRow(index)"
              @mouseleave="onHoverRow(-1)"
            >
              {{ index + 1 }}
            </td>
            <td
              style="width: 40px"
              class="text-center"
              v-bind:class="{ 'row-hover': highlightRow === index }"
              @mouseover="onHoverRow(index)"
              @mouseleave="onHoverRow(-1)"
              v-if="!editable"
            >
              <button
                v-show="newUserNewHedge.length > 1"
                class="btn detailView"
                @click="deleteRow(item)"
              >
                <i class="fa fa-trash"></i>
              </button>
            </td>
            <td
              v-bind:class="{ 'row-hover': highlightRow === index }"
              @mouseover="onHoverRow(index)"
              @mouseleave="onHoverRow(-1)"
            >
              <span v-if="!editable">
                <input
                  type="date"
                  class="optim-input"
                  v-model="item.date"
                  @input="val => onUserSingleNotionalChange"
                />
              </span>
              <span v-else>
                {{ item.date | dateFormat }}
              </span>
            </td>
            <td
              v-bind:class="{ 'row-hover': highlightRow === index }"
              @mouseover="onHoverRow(index)"
              @mouseleave="onHoverRow(-1)"
            >
              <span v-if="!editable">
                <InputNumber
                  v-model.number="item.newHedge"
                  :tableFormat="true"
                  :pasted="pasted"
                />
              </span>
              <span v-else>
                {{ item.newHedge | formatM }}
              </span>
            </td>
            <td
              style="text-align: right;"
              v-for="(itm, idx) in keys"
              :key="idx"
              v-bind:class="{ 'row-hover': highlightRow === index }"
              @mouseover="onHoverRow(index)"
              @mouseleave="onHoverRow(-1)"
            >
              <span v-if="!editable">
                {{ item[itm] | formatCurr }}
              </span>
              <span
                v-else-if="
                  selectedLegQuote.includes(idx) && quoteObjective === 'strike'
                "
                style="padding-right: 49%"
              >
                <i class="fa fa-question"></i>
              </span>
              <span v-else>
                <input
                  v-model.number.lazy="item[itm]"
                  placeholder="spot"
                  class="optim-input"
                  @change="onUserStrikeChange"
                />
              </span>
            </td>
            <td
              style="text-align: right;"
              v-bind:class="{ 'row-hover': highlightRow === index }"
              @mouseover="onHoverRow(index)"
              @mouseleave="onHoverRow(-1)"
            >
              {{ item.premium | formatM }}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="col col-11" style="height: 100%; overflow: auto;">
      <table class="table table-sm table-borderless real_time_table">
        <thead>
          <tr>
            <th style="width: 70px" colspan="2" v-if="!editable">TOTAL</th>
            <th style="width: 30px" v-else></th>
            <th class="text-center" v-if="!editable">
              <button @click="add" class="btn detailView mr-2">
                <i class="fa fa-plus"></i>
              </button>
              NEW DATE
            </th>
            <th v-else></th>
            <th style="font-size: 1rem; text-align: right;" v-if="!editable">
              <span class="mr-2">{{ allSubTotal | formatM }}</span>
            </th>
            <th style="font-size: 1rem; text-align: center;" v-else>
              {{ allSubTotal | formatM }}
            </th>
            <th
              style="font-size: 1rem; text-align: right;"
              v-for="(ave, idx) in newAverages"
              :key="idx"
            >
              <span
                class="mr-1"
                v-if="!editable && idx < newAverages.length - 1"
              >
                {{ ave | formatCurr }}
              </span>
              <span
                class="mr-1"
                v-else-if="!editable && idx >= newAverages.length - 1"
              >
                {{ ave | formatM }}
              </span>
              <span
                v-else-if="
                  selectedLegQuote.includes(idx) && quoteObjective === 'strike'
                "
                style="padding-right: 49%"
              >
                <i class="fa fa-question"></i>
              </span>
              <span v-else>
                <input
                  class="optim-input"
                  :value="ave"
                  @input="val => onUserSingleAveChange(val, idx)"
                />
              </span>
            </th>
          </tr>
        </thead>
      </table>
    </div>
    <div v-show="showStripData" class="trade-date-notional-div">
      <div
        class="row f-row mt-1 mb-1"
        style="vertical-align: middle!important;"
      >
        <div class="col col-6 txt-trade-div">
          FREQUENCY:
        </div>
        <div class="col col-6 inline-ul selectDiv">
          <select
            class="dropdown-form"
            v-model="newFrequency"
            @change="onUserFrequencySelection"
          >
            <option
              v-for="option in frequencyOptions"
              :value="option.value"
              :key="option.id"
            >
              {{ option.text }}
            </option>
          </select>
        </div>
      </div>
      <div
        class="row f-row mt-1 mb-1"
        style="vertical-align: middle!important;"
      >
        <div class="col col-6 txt-trade-div">
          INITIAL DATE:
        </div>
        <div class="col col-6">
          <input
            type="date"
            class="custom-input"
            v-model="newInitialDate"
            @change="onUserDateChange"
          />
        </div>
      </div>
      <div
        class="row f-row mt-1 mb-1"
        style="vertical-align: middle!important;"
      >
        <div class="col col-6 txt-trade-div">
          # OF DATES:
        </div>
        <div class="col col-6 inline-ul">
          <input
            type="number"
            class="custom-input"
            v-model="newNDates"
            @change="onUserNDatesChange"
          />
        </div>
      </div>
      <div
        class="row f-row mt-1 mb-1"
        style="vertical-align: middle!important;"
      >
        <div class="col col-6 txt-trade-div">
          AMOUNT PER DATE:
        </div>
        <div class="col col-6 inline-ul">
          <InputNumber
            :value="notional"
            @input="val => onUserNotionalChange(val)"
          />
        </div>
      </div>
      <div
        class="row f-row mt-3 justify-content-center"
        style="vertical-align: middle!important;"
      >
        <div class="col col-4 txt-trade-div text-center">
          <input
            type="button"
            id="stripClose"
            class="inputFile"
            @click="showStripData = false"
          />
          <label for="stripClose">Close</label>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { date2Str } from "@/_core/_helpers/_helpers.js";
import { Holidays } from "@/_core/_helpers/holidays/Holidays";
import { nextDateByFrequency } from "@/_core/data/Optimizer";
import { SheetsTransaction } from "@/_core/export/SheetsTransaction";
import { format, timeParse, timeFormat } from "d3";
import InputNumber from "@/components/InputNumber";

export default {
  name: "dateNotional",
  components: {
    InputNumber
  },
  props: {
    averages: { required: true, default: () => [] },
    currencySpecs: { required: true, default: () => [] },
    editable: { required: false, type: Boolean, default: false },
    frequency: { required: true, default: () => [] },
    frequencyOptions: { required: true, default: () => [] },
    getCountriesPair: { required: true },
    initialDate: { required: true, default: () => [] },
    nDates: { required: true, default: () => [] },
    notional: { required: true, default: () => [] },
    position: { required: true, default: () => [] },
    quoteObjective: { required: false, default: "strike" },
    selectedAsset: { required: true, default: () => [] },
    selectedLegQuote: { required: false, default: -1 },
    strategies: { required: true, default: () => [] },
    strategyLegs: { required: true, default: () => [] },
    userNewHedge: { required: true, default: () => [] }
  },
  data() {
    return {
      allNotional: 100000,
      allPercent: 0.1,
      hedgeChanged: false,
      highlightRow: -1,
      keys: [],
      newAverages: [],
      newFrequency: null,
      newInitialDate: null,
      newNDates: null,
      newPosition: null,
      newSelectedAsset: 0,
      newUserNewHedge: [],
      object: undefined,
      pasted: false,
      sheetTransaction: null,
      showStripData: false,
      tableData: [],
      tableRow: [],
      text: undefined,
      textIn: ""
    };
  },
  created() {
    try {
      this.countrySpecs = this.$store.state.countries.all.items;
    } catch (error) {
      console.log(`Error countries ${error}`);
    }
  },
  mounted() {
    this.newUserNewHedge = this.userNewHedge;
    if (this.newUserNewHedge.length > 0) {
      this.getKeys();
    }
    this.newFrequency = this.frequency;
    this.newSelectedAsset = this.selectedAsset;
    this.newPosition = this.position;
    this.newInitialDate = this.initialDate;
    this.newNDates = this.nDates;
    if (this.editable) {
      this.newAverages = this.averages.slice(1);
    } else {
      this.newAverages = this.averages;
    }
  },
  watch: {
    userNewHedge() {
      this.newUserNewHedge = this.userNewHedge;
      if (this.newUserNewHedge.length > 0) {
        this.getKeys();
      }
    },
    averages(val) {
      if (this.editable) {
        this.newAverages = val.slice(1);
      } else {
        this.newAverages = val;
      }
    },
    frequency() {
      this.newFrequency = this.frequency;
    },
    selectedAsset() {
      this.newSelectedAsset = this.selectedAsset;
    },
    position() {
      this.newPosition = this.position;
    },
    initialDate() {
      this.newInitialDate = this.initialDate;
    },
    nDates() {
      this.newNDates = this.nDates;
    }
  },
  computed: {
    allSubTotal() {
      return this.newUserNewHedge
        .map(item => +item.newHedge)
        .reduce((a, b) => a + b, 0);
    },
    selectedPositionBoolean: {
      get() {
        return this.newPosition === "sell";
      },
      set() {
        return false;
      }
    }
  },
  filters: {
    formatM: function(val) {
      return val === null || val === 0 ? "-" : format(",.0f")(val);
    },
    formatCurr: function(val) {
      return val === null || val === 0 ? "-" : format(",.5r")(val);
    },
    formatPercent: function(value) {
      if (value) {
        return format(".1%")(value);
      }
    },
    dateFormat: function(val) {
      return val === null || val === "" || val === 0
        ? "-"
        : timeFormat("%d %b %y")(timeParse("%Y-%m-%d")(val));
    }
  },
  methods: {
    onHoverRow(idx) {
      this.highlightRow = idx;
    },
    getKeys() {
      let ks = Object.keys(this.newUserNewHedge[0]);
      if (this.editable === false) {
        this.keys = ks.filter(
          d => d !== "date" && d !== "newHedge" && d !== "premium"
        );
      } else {
        this.keys = ks.filter(
          d =>
            d !== "date" && d !== "newHedge" && d !== "fwd" && d !== "premium"
        );
      }
    },
    onChange(e) {
      const files = e.target.files;
      const fileReader = new FileReader();
      fileReader.onload = ev => {
        this.newUserNewHedge = [];
        const data = ev.target.result;
        this.sheetTransaction = new SheetsTransaction();
        this.sheetTransaction.set_data(data);
        this.sheetTransaction.set_headers(this.newUserNewHedge);
        this.indexes = ["date", "newHedge"];
        this.sheetTransaction.import(this.indexes, {
          date: this.getCountriesPair()
        });
      };
      fileReader.readAsBinaryString(files[0]);
      setTimeout(() => {
        this.$emit("eventOnUserTableChange", this.newUserNewHedge);
      }, 1000);
    },
    paste(e) {
      let holidays = new Holidays(this.getCountriesPair());
      this.pasted = true;
      this.newUserNewHedge = [];
      this.text = e.clipboardData.getData("text");
      // try{
      let rows = this.text.split("\n");
      // rows.pop();
      for (let row of rows) {
        let cells = row.split("\t");
        let even = true;
        let newHedgeObject = {};
        for (let cell of cells) {
          if (even) {
            newHedgeObject.date = holidays.searchAvailableDate(cell);
            even = false;
          } else {
            newHedgeObject.newHedge = +(+cell.replace(",", "")).toString();
            even = true;
          }
        }
        this.newUserNewHedge.push(newHedgeObject);
      }
      this.$emit("eventOnUserTableChange", this.newUserNewHedge);

      setTimeout(() => {
        this.textIn = "";
      }, 2000);
    },
    add() {
      this.hedgeChanged = true;
      this.newNDates = +this.newNDates + 1;
      this.$emit("eventUpdateNDates", this.newNDates);
      let dat = timeParse("%Y-%m-%d")(
        this.newUserNewHedge[this.newUserNewHedge.length - 1].date
      );
      this.newUserNewHedge.push({
        date: date2Str(nextDateByFrequency(this.newFrequency, dat), 0),
        newHedge: this.notional
      });
      this.onUserSingleNotionalChange();
    },
    deleteRow(item) {
      this.hedgeChanged = true;
      this.newNDates = +this.newNDates - 1;
      this.$emit("eventUpdateNDates", this.newNDates);
      this.newUserNewHedge.splice(this.newUserNewHedge.indexOf(item), 1);
      this.onUserSingleNotionalChange();
    },
    remove(item, index) {
      this.hedgeChanged = true;
      this.selectedHedge.splice(index, 1);
    },
    onUserFrequencySelection() {
      this.$emit("eventOnUserFrequencySelection", this.newFrequency);
    },
    onUserAssetSelection() {
      this.$emit("eventOnUserAssetSelection", this.newSelectedAsset);
    },
    onUserPositionChange() {
      this.newPosition = this.newPosition === "buy" ? "sell" : "buy";
      this.$emit("eventOnUserPositionChange", this.newPosition);
    },
    onUserNotionalChange(val) {
      this.$emit("eventOnUserNotionalChange", val);
    },
    onUserSingleNotionalChange() {
      this.$emit("eventOnUserTableChange", this.newUserNewHedge);
    },
    onUserDateChange() {
      this.$emit("eventOnUserDateChange", this.newInitialDate);
    },
    onUserNDatesChange() {
      this.$emit("eventOnUserNDatesChange", this.newNDates);
    },
    onUserStrikeChange() {
      console.log("strike change");
    },
    onUserSingleAveChange(val, idx) {
      console.log(val);
      this.newAverages[idx] = val;
      console.log("single ave change");
    }
  }
};
</script>

<style scoped>
.toggle__button_rt .toggle__switch_rt::after,
.toggle__button_rt .toggle__switch_rt::before {
  content: "BUY";
  font-size: 0.8rem !important;
}
.actives .toggle__switch_rt::after,
.actives .toggle__switch_rt::before {
  content: "SELL";
}
.selectDiv:after {
  color: var(--textactive-2) !important;
}
</style>
